// extracted by mini-css-extract-plugin
module.exports = {"form":"NewCommentForm_form__xIIWr","loading":"NewCommentForm_loading__9LAUi","control":"NewCommentForm_control__1ZJPZ","actions":"NewCommentForm_actions__Xv-Jw"};